import format from 'date-fns/format';
import isToday from 'date-fns/isToday';
import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import { DivWithShadowAlternate } from '@styled';
import ICSCAvatar from './ICSCAvatar';

const breakpoint = mediaQueries.md;

const ContainerStyled = styled(DivWithShadowAlternate)`
    margin-bottom: 16px;
    position: relative;

    .tooltip {
        filter: drop-shadow(0px 0px 12px rgba(87, 87, 87, 0.3));
        background-color: #fff;
        opacity: 1;
        padding: 8px 16px;
        white-space: nowrap;
        z-index: 999999;
    }
`;

const ContainerClickableStyled = styled.div`
    border-left: 8px solid ${props => (props.isActive ? colors.azure : colors.white)};
    cursor: pointer;
    padding: 9px;
    transition: border-color 0.2s ease-in-out;

    :hover {
        border-color: ${props => (props.isActive ? colors.azure : colors.backgroundGray)};
    }
`;

const ContainerInnerStyled = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
`;

const LastMessageTimeStyled = styled.p`
    font-size: 0.8rem;
    color: #333333;
    margin-bottom: 0;
    text-align: right;
    margin-right: 15px;
    margin-left: 30px;
    line-height: 1.2rem;
    @media ${breakpoint} {
        display: block;
    }
`;

const LastMessageTextStyled = styled.p`
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: calc(90%);
    flex: 1;
    margin-top: 5px;
    line-height: 1.2rem;
    margin-bottom: 0;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 0.9rem;
    font-weight: ${props => (props.isActive ? 700 : 400)};

    @media ${breakpoint} {
        display: block;
    }
`;

const NameStyled = styled.p`
    line-height: 1.2rem;
    margin-bottom: 0;
    font-family: 'Red Hat Display', sans-serif;
    font-size: 0.9rem;
    font-weight: 700;

    @media ${breakpoint} {
        display: block;
    }
`;

const formatDate = timestamp => {
    const date = new Date(timestamp * 1000);
    const year = date.getFullYear();

    if (isToday(date)) {
        return format(date, 'h:mm a');
    }

    if (year === new Date().getFullYear()) {
        return format(date, 'MMM dd');
    }

    return year;
};

const AnnouncementItem = ({ announcement, isActive = false, onClickItem }) => {
    const body = useMemo(() => {
        return announcement.body.replace(/<[^>]*>/g, '');
    }, [announcement]);

    return (
        <ContainerStyled>
            <ContainerClickableStyled isActive={isActive} onClick={() => onClickItem(announcement)}>
                <ContainerInnerStyled>
                    <div style={{ width: '48px' }}>
                        <ICSCAvatar />
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginLeft: '15px',
                            minWidth: 0,
                            flex: '1 100%',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                            }}
                        >
                            <div style={{ position: 'relative' }}>
                                <NameStyled>ICSC</NameStyled>
                            </div>

                            <LastMessageTimeStyled>
                                {formatDate(announcement.created_at_timestamp)}
                            </LastMessageTimeStyled>
                        </div>

                        <LastMessageTextStyled isActive={isActive}>{announcement.subject}</LastMessageTextStyled>
                        <LastMessageTextStyled isActive={isActive}>{body}</LastMessageTextStyled>
                    </div>
                </ContainerInnerStyled>
            </ContainerClickableStyled>
        </ContainerStyled>
    );
};

AnnouncementItem.propTypes = {
    announcement: PropTypes.any,
    isActive: PropTypes.bool,
    onClickItem: PropTypes.func,
};

export default AnnouncementItem;
